import { Shadows, YStack, type YStackProps } from 'smoothie';

const PaycheckRoutingCard = ({
    onPress,
    disabled,
    children,
    ...props
}: YStackProps) => {
    return (
        <YStack
            onPress={onPress}
            backgroundColor={disabled ? '$gray400' : '$gray0'}
            paddingVertical={16}
            paddingHorizontal={22}
            borderWidth={1}
            borderColor={disabled ? '$gray600' : '$gray200'}
            borderRadius={20}
            style={{ ...Shadows.SMALL }}
            gap={16}
            overflow="hidden"
            {...props}
        >
            {children}
        </YStack>
    );
};

export default PaycheckRoutingCard;
